export const styles = {
  link: {
    textDecoration: 'none',
  },
  disabled: {
    cursor: 'pointer',
  },
};
